export enum EnumCadastroTipo {
    FUNCIONARIO = 0,
    REPRESENTANTE = 1,
    CLIENTE = 2,
    FORNECEDOR = 3,
    TRANSPORTADORA = 4,
}